import { Boton } from "asocomponents"
import { useDispatch, useSelector } from "react-redux";
import { useMostrarMensajeConfirmacion } from "../../../helpers/mensajeria"
import { MENSAJESAPP } from "../../../const/constantes.js";
import { WindowOpener } from "../../../helpers/window-opener"
import { WEBURLEGALES } from "../../../helpers/frontend.js"
import { useEffect, useState } from "react";

function GrillaAdjuntos({ adjuntos, mostrarBotonAcciones = true, setDocumentos }) {
    const mostrarMensajeConfirmacion = useMostrarMensajeConfirmacion()
    const dispatch = useDispatch()

    const [message, setMessage] = useState("")
    const [resultado, setResultado] = useState([])
    const [existenRdos, setExistenRdos] = useState(true)
    //PARA EL PAGINADO
    const [paginaActual, setPaginaActual] = useState(1)
    const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

    const openUrl = (doc) => {
        let pathPDF

        console.log(doc)
        if (doc.baseUri) {
            pathPDF = doc.path.endsWith('.pdf')
                ? doc.baseUri + '/' + doc.path
                : doc.baseUri + '/' + doc.path + '/' + doc.nombre
        } else {
            pathPDF = doc.path
        }

        if (!pathPDF) return

        const width = 600;
        const height = 500;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        window.open(
            pathPDF,
            "popupWindow",
            `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes`
        )
    }

    const confirmarEliminarDocumento = (indice) => {
        const documentosFiltrados = adjuntos.filter(doc => doc.indice !== indice);
        dispatch(setDocumentos(documentosFiltrados));
    }

    const handlerEliminarDocumento = (indice) => {
        mostrarMensajeConfirmacion(MENSAJESAPP.DOCDIGITALIZADOS.CONFIRMARELIMINARDOC, () => confirmarEliminarDocumento(indice), "question")
    }

    const sonResponse = (err, res) => {
        if (err) {
            setMessage(res)
        } else {
            setMessage(res)
        }
    }

    //#region paginado y fetchData
    const indiceUltimoElemento = paginaActual * elementosPorPagina
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
    let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

    const elementosPaginados =
        resultado === null
            ? []
            : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina)
    }

    useEffect(() => {
        adjuntos && setResultado(adjuntos)
        adjuntos && setExistenRdos(adjuntos.length > 0)
    }, [adjuntos])

    return (
        <>
            <div className="overflow-x-auto">
                <div className="shadow-md sm:rounded-lg w-[87%] mx-auto">
                    <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-full">
                        <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                            <tr>
                                <th
                                    scope="col"
                                    className="text-center  py-1"
                                    style={{ width: "35%" }}
                                >
                                    Tipo de Archivo
                                </th>
                                <th
                                    scope="col"
                                    className="text-center  py-1"
                                    style={{ width: "75%" }}
                                >
                                    Nombre
                                </th>
                                <th scope="col" className="text-center  py-1" style={{ width: "10%" }}
                                ></th>
                            </tr>
                        </thead>
                        <tbody>
                            {elementosPaginados && elementosPaginados.map((doc, index) => (
                                <tr
                                    className="bg-white border-b hover:bg-gray-50 text-[0.6rem]"
                                    key={doc.indice}
                                >
                                    <td className="text-center py-1">{doc.tipo}</td>
                                    <td className="text-center py-1">{doc.nombre}</td>
                                    {mostrarBotonAcciones &&
                                        <td className="text-center py-1">
                                            {doc.esThuban ?
                                                <WindowOpener url={`${WEBURLEGALES}/VisorAdjuntoThuban/${doc.internal}/${doc.origen}`} bridge={sonResponse} name="VisorArchivo">
                                                    <Boton icono="eye" height="h-6" width="w-8" alt="Ver Adjunto" />
                                                </WindowOpener>
                                                :
                                                <Boton
                                                    type="button"
                                                    icono="eye"
                                                    alt="Ver Adjunto"
                                                    width="w-8"
                                                    height="h-6"
                                                    onClick={() => openUrl(doc)}
                                                />
                                                }
                                        </td>
                                    }
                                    <td className="text-center py-1">
                                        {!mostrarBotonAcciones && <Boton type="button" height="h-6" icono="eliminar" alt="Eliminar" width="w-8" onClick={() => handlerEliminarDocumento(doc.indice)} />}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {!existenRdos &&
                    <div className="flex flex-row items-center justify-center h-full">
                        <div className="font-semibold text-m text-center m-4">
                            Aun no existen documentos digitalizados
                        </div>
                    </div>
                }
                <div className="col-span-2 flex justify-end items-center m-2 mr-20">
                    <span className="text-sm m-1">
                        Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
                    </span>
                    <button
                        className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                    >
                        {"<"}
                    </button>
                    <button
                        className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
                    >
                        {">"}
                    </button>
                </div>
            </div>
        </>
    )
}

export default GrillaAdjuntos